import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ImageBox from '../../master/ImageBox';


export default function UploadDocs({attachments, insuranceType, uploadDoc, changeStep, losses, hasCoroukie ,userType,lossesIndex =1}) {
    const { t } = useTranslation();
    const {accidentInfo,insuranceCode} = useSelector(store => store);
    // const index = losses.length !== 0 ? losses.length -1 : losses.length;
    // const index = lossesIndex -1;
    const coroukie_images = attachments.filter(itm => itm.filename.includes('coroukie_image'))
    // function renderButton(name, title) {
    //     const image = attachments.find(itm => itm.filename === name);
    //     return (
    //         // <div className='upload-parent'>
    //         //     <div className='upload-text'>{title}</div>
    //         //     {
    //         //68*40
    //                 image ?
    //                     <img className='my10' src={`${url}/files?uid=${image.uid}&width=85&height=60`} alt='img'/> :
    //                     'default'
    //                     // <div className='upload-icon-parent'>
    //                     //     {/* <i className='fas fa-image'/> */}
    //                     //     {/* <img src={AddImageOutline}/> */}
    //                     //     <img src={name.includes('back') ? imagePlaceholders['back'] :imagePlaceholders[name.split('_')[1]]}/>
    //                     // </div>
    //         //     }
    //         // </div>
    //     )
    // }

    return (
        <>
         {/* <div className='complete-content'> */}
            {userType === 'culprit' &&
            // <div className='box-wrapper'>
            <>
                {/* <div className='title'>{t('Culprit docs')}</div> */}
                {/* <div className='complete-image-box'> */}
                    {
                        insuranceCode === 'l9Rx6eo2'&&
                        <ImageBox
                            title={t('ID card')}
                            name='culprit_national_cart_image'
                            label='id_card'
                            attachments={attachments}
                            uploadDoc={uploadDoc}
                        />
                    }
                    <ImageBox
                        title={t('License')}
                        name='culprit_license_image'
                        label='license_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    <ImageBox
                        title={t('License back')}
                        name='culprit_license_back_image'
                        label='back_license_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    <ImageBox
                        title={t('Car card')}
                        name='culprit_vehicle_card_image'
                        label='vehicle_card_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    <ImageBox
                        title={t('Car back card')}
                        name='culprit_vehicle_card_back_image'
                        label='vehicle_card_back_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    <ImageBox
                        title={t('Third insurance')}
                        name='culprit_third_image'
                        label='third_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    {/* <div className='upload-parent'>
                    <div className='upload-text'>{t('License')}</div>
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_license_image', `${t('License')}`)}
                        // renderBtn={renderButton('culprit_license_image', `${t('License')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_license_image', done)}
                        label='license_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_license_image')}
                    />
                    </div> */}
                    {/* <div className='upload-parent'>
                    <div className='upload-text'>{t('License back')}</div>
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_license_back_image', `${t('License back')}`)}
                        // renderBtn={renderButton('culprit_license_back_image', `${t('License back')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_license_back_image', done)}
                        label='back_license_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_license_back_image')}
                    />
                    </div> */}
                    {/* <div className='upload-parent'>
                    <div className='upload-text'>{t('Car card')}</div>
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_vehicle_card_image', `${t('Car card')}`)}
                        // renderBtn={renderButton('culprit_vehicle_card_image', `${t('Car card')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_vehicle_card_image', done)}
                        label='vehicle_card_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_vehicle_card_image')}
                    />
                    </div> */}
                    {/* <div className='upload-parent'>
                    <div className='upload-text'>{t('Car back card')}</div>
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_vehicle_card_back_image', `${t('Car back card')}`)}
                        // renderBtn={renderButton('culprit_vehicle_card_back_image', `${t('Car back card')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_vehicle_card_back_image', done)}
                        label='vehicle_card_back_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_vehicle_card_back_image')}
                    />
                    </div> */}
                    {/* <div className='upload-parent'>
                    <div className='upload-text'>{t('Third insurance')}</div>
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_third_image', `${t('Third insurance')}`)}
                        // renderBtn={renderButton('culprit_third_image', `${t('Third insurance')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_third_image', done)}
                        label='third_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_third_image')}
                    />
                    </div> */}
                    {
                        insuranceType === 'body' &&
                        <ImageBox
                            title={t('Body insurance')}
                            name='culprit_body_image'
                            label='body_image'
                            attachments={attachments}
                            uploadDoc={uploadDoc}
                        />
                        // <div className='upload-parent'>
                        // <div className='upload-text'>{t('Body insurance')}</div>
                        // <ImagePickerModal
                        //     renderBtn={renderButton('culprit_body_image', t('Body insurance'))}
                        //     upload={(image, done) => uploadDoc(image, 'culprit_body_image', done)}
                        //     label='body_image'
                        //     imageUid={attachments.find(itm => itm.filename === 'culprit_body_image')}
                        // />
                        // </div>
                    }
                    {
                        accidentInfo.has_coroukie &&
                        <>
                        {coroukie_images.length > 0 && coroukie_images.map(itm=>(
                            <ImageBox
                                title={t('Police Report')}
                                name={`${itm.filename}`}
                                label='croukie_image'
                                attachments={attachments}
                                uploadDoc={uploadDoc}
                            />
                            // <div className='upload-parent'>
                            // <div className='upload-text'>{t('Police Report')}</div>
                            // <ImagePickerModal
                            //     renderBtn={renderButton(`${itm.filename}`, t('Police Report'))}
                            //     // upload={(image, done) => uploadDoc(image, 'coroukie_image', done)}
                            //     label='croukie_image'
                            //     imageUid={attachments.find(itm => itm.filename === `${itm.filename}`)}
                            // />
                            // </div>
                        ))}
                        <ImageBox
                            title={t('Police Report')}
                            name={`coroukie_image${coroukie_images.length +1}`}
                            label='croukie_image'
                            attachments={attachments}
                            uploadDoc={uploadDoc}
                        />
                        {/* <div className='upload-parent'>
                        <div className='upload-text'>{t('Police Report')}</div>
                        <ImagePickerModal
                            renderBtn={renderButton(`coroukie_image${coroukie_images.length +1}`, t('Police Report'))}
                            upload={(image, done) => uploadDoc(image, `coroukie_image${coroukie_images.length +1}`, done)}
                            label='croukie_image'
                            // imageUid={attachments.find(itm => itm.filename === `coroukie_image`)}
                        />
                        </div> */}
                        </>
                    }
                {/* </div> */}
            {/* </div> */}
            </>
}
            {
                userType !== 'culprit' && 
                //insuranceType === 'third' &&
                    // losses.map((itm, index) => (
                        <>
                        {/* <div className='box-wrapper' key={index}> */}
                            {/* <div className='title'>{`${t('Losses docs')} ${t(latinAlphabet[index])}`}</div> */}
                            {/* <div className='complete-image-box'> */}
                    {
                    // insuranceCode === 'l9Rx6eo2'&&
                    <ImageBox
                        title={t('ID card')}
                        name={`losses_national_cart_image${lossesIndex}`}
                        label='id_card'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    }
                    <ImageBox
                        title={t('License')}
                        name={`losses_license_image${lossesIndex}`}
                        label='license_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    <ImageBox
                        title={t('License back')}
                        name={`losses_license_back_image${lossesIndex}`}
                        label='back_license_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    <ImageBox
                        title={t('Car card')}
                        name={`losses_vehicle_card_image${lossesIndex}`}
                        label='vehicle_card_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    <ImageBox
                        title={t('Car back card')}
                        name={`losses_vehicle_card_back_image${lossesIndex}`}
                        label='vehicle_card_back_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                    <ImageBox
                        title={t('Third insurance')}
                        name={`losses_third_image${lossesIndex}`}
                        label='third_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                                {/* <div className='upload-parent'>
                                <div className='upload-text'>{t('License')}</div>
                                <ImagePickerModal
                                    // renderBtn={renderButton(`losses_license_image${index + 1}`, `${t('License')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    renderBtn={renderButton(`losses_license_image${index + 1}`, `${t('License back')}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_license_image${index + 1}`, done)}
                                    label='license_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_license_image${index + 1}`)}
                                />
                                </div>
                                <div className='upload-parent'>
                                <div className='upload-text'>{t('License back')}</div>
                                <ImagePickerModal
                                    // renderBtn={renderButton(`losses_license_back_image${index + 1}`, ` ${t('License back')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    renderBtn={renderButton(`losses_license_back_image${index + 1}`, ` ${t('License back')}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_license_back_image${index + 1}`, done)}
                                    label='back_license_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_license_back_image${index + 1}`)}
                                />
                                </div>
                                <div className='upload-parent'>
                                <div className='upload-text'>{t('Car card')}</div>
                                <ImagePickerModal
                                    // renderBtn={renderButton(`losses_vehicle_card_image${index + 1}`, `${t('Car card')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    renderBtn={renderButton(`losses_vehicle_card_image${index + 1}`, `${t('Car card')}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_vehicle_card_image${index + 1}`, done)}
                                    label='vehicle_card_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_vehicle_card_image${index + 1}`)}
                                />
                                </div>
                                <div className='upload-parent'>
                                <div className='upload-text'>{t('Car back card')}</div>
                                <ImagePickerModal
                                    // renderBtn={renderButton(`losses_vehicle_card_back_image${index + 1}`, `${t('Car back card')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    renderBtn={renderButton(`losses_vehicle_card_back_image${index + 1}`, `${t('Car back card')}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_vehicle_card_back_image${index + 1}`, done)}
                                    label='vehicle_card_back_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_vehicle_card_back_image${index + 1}`)}
                                />
                                </div>
                                <div className='upload-parent'>
                                <div className='upload-text'>{t('Third insurance')}</div>
                                <ImagePickerModal
                                    // renderBtn={renderButton(`losses_third_image${index + 1}`, `${t('Third insurance')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    renderBtn={renderButton(`losses_third_image${index + 1}`, `${t('Third insurance')}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_third_image${index + 1}`, done)}
                                    label='third_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_third_image${index + 1}`)}
                                />
                                </div> */}
                            {/* </div> */}
                        {/* </div> */}
                        </>
                    //))
            }
            {/* <div className='nav-button-parent'>
                <button className='navButton mr5' onClick={() => changeStep(2)}>
                    {t('Next step')}
                    <i className='fas fa-chevron-down'/>
                </button>
                {!!hasCoroukie &&
                    <button
                        className='navButton prev ml5'
                        onClick={() => changeStep(0)}
                    >
                       {t('Prev step')}
                        <i className='fas fa-chevron-up'/>
                    </button>
                }
            </div> */}
        {/* </div> */}
        </>
    );

}
